import { YOO_FINDS_CDN } from "@/common";

export const BANNER_BG_LA_2025 = `${YOO_FINDS_CDN}/pc/la-2025/banner/banner-bg-v5.webp`;

export const FASSMOSS_LOGO_LA_2025 = `${YOO_FINDS_CDN}/pc/la-2025/header/fassmoss-logo.webp`;

export const SCHEDULE_OBJECTS = `${YOO_FINDS_CDN}/pc/la-2025/schedule/objects.webp`;

export const SCHEDULE_FLOWER = `${YOO_FINDS_CDN}/pc/la-2025/schedule/flower.webp`;

export const SCHEDULE_SAWTOOTH_LA_2025 = `${YOO_FINDS_CDN}/pc/la-2025/schedule/sawtooth.webp`;

export const LA_SIGN_UP_BANNER = `${YOO_FINDS_CDN}/pc/la-2025/tickets-page/tickets-banner.webp`;
